import * as React from 'react';
import {withStyles,
  WithStyles,
  StyleRules,
  ClassNameMap
} from '@mui/styles';
import {CircularProgress} from '@mui/material';
import {Theme} from '@mui/material/styles';
import * as request from 'superagent';
import Dropzone from '~common/components/versioned-document-dropzone';
import {red, green, grey} from '@mui/material/colors';
import {Icon} from '@mui/material';
import {IconButton} from '@mui/material';
import {
  Button,
  ListItemText,
  ListItemIcon,
  ListSubheader,
  FormLabel,
  FormControl,
  FormGroup,
  FormHelperText
} from '@mui/material';
import PortalUserContext, {UserType} from '~common/lib/portal-user-context';
import {Menu, MenuItem} from '@mui/material';
import * as moment from 'moment';
import {Tooltip} from '@mui/material';
import PortalUser from '~common/lib/portal-user-context';

const styles = (theme: Theme): StyleRules => ({
  container: {
    width: '100%',
    marginTop: '-3px'
  },
  document: {
    display: 'flex'
  },
  defaultDocument: {
    color: '#2e2eb8'
  },
  deleteButton: {
    padding: 12
  },
  noDocument: {
    display: 'flex',
    'align-items': 'center',
    'justify-content': 'center',
    fontWeight: 500,
    color: '#ccc',
    marginLeft: 15,
    marginTop: 7
  },
  documentIcon: {
    padding: 5,
    cursor: 'pointer'
  },
  documentFileName: {
    padding: 5,
    paddingRight: 10,
    marginTop: 5,
    cursor: 'pointer'
  },
  dropzone: {
    border: '1px dashed #ccc',
    padding: 15,
    marginLeft: 10,
    marginTop: 0,
    backgroundColor: grey[100],
    flex: 'auto',
    display: 'flex',
    'align-items': 'center',
    'justify-content': 'center',
    cursor: 'pointer'
  },
  dropzoneMin: {
    border: '0px dashed #ccc',
    paddingTop: 8,
    marginLeft: 10,
    marginTop: 0,
    // backgroundColor: grey[100],
    width: '2rem',
    height: '2rem',
    display: 'flex',
    'align-items': 'center',
    'justify-content': 'center',
    cursor: 'pointer'
  },
  dropzoneActive: {
    backgroundColor: green[100]
  },
  dropzoneReject: {
    backgroundColor: red[100]
  },
  dropzoneDisabled: {
    color: grey[400]
  },
  loading: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: 44,
    minHeight: 44
  },
  listArea: {
    display: 'flex',
    alignContent: 'flex-start',
    alignItems: 'center'
  },
  subheader: {
    userSelect: 'none',
    lineHeight: 2.5,
    '&:focus': {
      outlineWidth: 0
    },
    backgroundColor: '#fff'
  },
  compactLabel: {
    fontSize: '0.75rem'
  },
  docusignSuccess: {
    color: green[600]
  },
  docusignFail: {
    color: red[600]
  },
  docusignUnk: {
    color: grey[600]
  }
});

var MAX_FILE_SIZE = 5242880;

interface Props extends React.HTMLProps<HTMLDivElement> {
  multiple?: boolean;
  preventDelete?: boolean;
  hideVersions?: boolean;
  suppressApiDelete?: boolean;
  alwaysOpenInNewWindow?: boolean;
  prompt?: string;
  noDocumentText?: string;
  accept?: string;
  url?: string;
  raw?: boolean; //returns the raw result after uploading.  Useful when uploading to the covert handler
  defaultDocumentURL?: string;
  versionedDocument: any;
  maxSize?: number;
  minSize?: number;
  label?: string;
  error?: boolean;
  helperText?: string;
  onVersionedDocumentChange: (versionedDocument: any) => void;
  onVersionedDocumentDelete?: (versionedDocument: any) => void;
  onUploadError?: (err: string) => void;
  onFileReject?: (rejectedFiles: Array<any>) => void;
  minimal?: boolean;
  parse?: boolean;
  required?: boolean;
  readOnly?: boolean;
}

type State = {
  prompt: string;
  accept: string;
  status: 'ready' | 'uploading' | 'uploaded';
  historyAnchorEl?: any;
  error?: any;
};

class VersionedDocumentField extends React.Component<
  Props & WithStyles<keyof typeof styles>,
  State
> {
  constructor(props: Props & WithStyles<keyof typeof styles>) {
    super(props);

    var accept: any;
    this.state = {
      status: 'ready',
      prompt: props.prompt || 'Drop file to upload new version',
      accept: props.accept
    };
  }



  onDrop = (acceptedFiles: Array<any>, rejectedFiles: Array<any>) => {
    const {parse} = this.props;
    
    if (rejectedFiles && rejectedFiles.length > 0) {
      if (this.props.onFileReject) {
        this.setState({
          error: "Invalid file type"
        }, ()=>{
          this.props.onFileReject(rejectedFiles);
        })
        // this.props.onFileReject(rejectedFiles);
      }
      rejectedFiles.forEach((f: any) => {
        if (f.file.size > (this.props.maxSize || MAX_FILE_SIZE)) {
          this.setState({
            status: 'ready',
            error: `File size cannot exceed ${(
              (this.props.maxSize || MAX_FILE_SIZE) /
              (1024 * 1024)
            ).toFixed(0)}MB`
          });
          return;
        }
      });
    } else {
      if (acceptedFiles && acceptedFiles.length > 0) {
        this.setState({status: 'uploading'}, () => {
          const {versionedDocument} = this.props;

          let vd = versionedDocument;
          if (!vd) {
            vd = {
              active: {},
              priorVersions: []
            };
          }
          // OK, we have one or more accepted files
          let parseFlag = '';
          if (parse) {
            parseFlag = '?parse=true';
          }
          for (let f of acceptedFiles) {
            request
              .post((this.props.url || `/api/attachment-storage`) + parseFlag)
              .attach(f.name, f)
              .then((response) => {
                if (response.ok) {
                  const att = {
                    fileName: f.name,
                    contentType: f.type,
                    size: f.size,
                    storageKey: response.body.storageKey,
                    data: response.body.data,
                    uploadedOn: new Date(),
                    uploadedBy: {
                      name: PortalUserContext.userContext.displayName,
                      email: PortalUserContext.userContext.email
                    },
                    retainAsPriorVersion: true
                  };

                  if (vd.active && Object.keys(vd.active).length > 0) {
                    if (!vd.priorVersions) {
                      vd.priorVersions = [];
                    }
                    if (vd.active && vd.active.retainAsPriorVersion != false) {
                      vd.priorVersions.push(vd.active);
                    }
                  }
                  vd.active = att;
                  this.props.onVersionedDocumentChange(vd);
                  this.setState({status: 'ready', error: null});
                } else {
                  if (this.props.onUploadError) {
                    this.props.onUploadError(response.body);
                  }

                  // Report the error to the user
                  this.setState({
                    status: 'ready',
                    error: 'An error occurred uploading the document'
                  });
                }
              })
              .catch((err) => {
                if (this.props.onUploadError) {
                  this.props.onUploadError(err);
                }
                // Report the error to the user
                this.setState({
                  status: 'ready',
                  error: 'An error occurred uploading the document'
                });
              });
          }
        });
      }
    }
  };

  onDelete = (idx: number, newWindow?: boolean) => (evt: any) => {
    const {versionedDocument} = this.props;

    let vd = versionedDocument;
    if (!versionedDocument) {
      vd = {
        active: {},
        priorVersions: []
      };
    }

    if (!vd.priorVersions) {
      vd.priorVersions = [];
    }

    if (vd.active && vd.active.retainAsPriorVersion != false) {
      vd.priorVersions.push(vd.active);
    }

    vd.active = null;

    if (this.props.onVersionedDocumentChange) {
      this.props.onVersionedDocumentChange(vd);
    }
    if (this.props.onVersionedDocumentDelete) {
      this.props.onVersionedDocumentDelete(vd);
    }
  };

  onClick = (fileName: string, storageKey: string, newWindow?: boolean) => (
    evt: any
  ) => {
  
    if (newWindow || this.props.alwaysOpenInNewWindow) {
      window.open(
        '/api/attachment-storage/' + storageKey + '/raw?fileName=' + encodeURIComponent(fileName),
        '_blank'
      );
    } else {
      window.location.href =
        '/api/attachment-storage/' + storageKey + '/raw?fileName=' + encodeURIComponent(fileName);
    }
  };

  onClickDocumentPath = (documentPath: string, newWindow?: boolean) => (
    evt: any
  ) => {
    if (newWindow || this.props.alwaysOpenInNewWindow) {
      window.open(documentPath, '_blank');
    } else {
      window.location.href = documentPath;
    }
  };

  handleShowHistory = (event: any) => {
    this.setState({historyAnchorEl: event.currentTarget});
  };

  handleHistoryClose = () => {
    this.setState({historyAnchorEl: null});
  };

  handleHistorySelect = (storageKey: string, newWindow?: boolean) => () => {
    if (newWindow || this.props.alwaysOpenInNewWindow) {
      window.open('/api/attachment-storage/' + storageKey + '/raw', '_blank');
    } else {
      window.location.href = '/api/attachment-storage/' + storageKey + '/raw';
    }
    this.setState({historyAnchorEl: null});
  };

  getFileInfo = (
    mimeType: string,
    classes: any
  ): {iconClass: string; newWindow: boolean} => {
    var iconClass: any;
    var newWindow: boolean;

    switch (mimeType) {
      case 'image/gif':
      case 'image/jpeg':
      case 'image/tiff':
      case 'image/png':
        iconClass = 'fa-file-image ' + classes.icon;
        newWindow = true;
        break;
      case 'application/pdf':
        iconClass = 'fa-file-pdf ' + classes.icon;
        newWindow = true;

        break;
      case 'application/msword':
      case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
        iconClass = 'fa-file-word ' + classes.icon;
        newWindow = true;
        break;
      case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
      case 'application/vnd.ms-excel':
        iconClass = 'fa-file-excel ' + classes.icon;
        newWindow = true;
        break;
      case 'text/plain':
        iconClass = 'fa-file-alt ' + classes.icon;
        newWindow = true;
        break;

      default:
        iconClass = 'fa-file ' + classes.icon;
        newWindow = true;
        break;
    }

    return {iconClass, newWindow};
  };

  docusignStatusIconClass = (status: string): any => {
    const {classes}: {classes: ClassNameMap} = this.props;
    var iconClass: any;
    if (!status) {
      status = 'unknown';
    }
    switch (status.toLowerCase()) {
      case 'completed':
        iconClass = classes.docusignSuccess;
        break;
      case 'voided':
        iconClass = classes.docusignFail;
        break;
      case 'declined':
        iconClass = classes.docusignFail;
        break;
      default:
        iconClass = classes.docusignUnk;
    }
    return iconClass;
  };

  render() {
    const {classes}: {classes: ClassNameMap} = this.props;
    const {
      minSize,
      maxSize,
      preventDelete,
      label,
      error,
      helperText,
      hideVersions,
      minimal,
      disabled,
      noDocumentText,
      required,
      readOnly,
      defaultDocumentURL
    } = this.props;
    const {historyAnchorEl, status} = this.state;

    var suppressVersions: bool = true;

    if (PortalUser.hasOneOfFeatures(['view_prior_versions']) && !hideVersions) {
      suppressVersions = false;
    }

    let usingDefault = false;
    let attachment = this.props.versionedDocument.active;
    if (!attachment || !attachment.storageKey) {
      if (this.props.versionedDocument.default) {
        attachment = this.props.versionedDocument.default;
        usingDefault = true;
      }
    }

    const priorVersions = this.props.versionedDocument.priorVersions || [];

    let documentView = (
      <div drop={this.onDrop} className={classes.noDocument}>
        {noDocumentText || 'No document uploaded'}
      </div>
    );

    // Manage errors
    // if there is a remote error use that
    let localError = error;
    let localHelperText = helperText;
    if (this.state.error) {
      localError = true;
      localHelperText = this.state.error;
    }
        // If there is a local error always use that

    var clickFn: Function;
    var fileName: string;

    var iconClass: any;
    var newWindow: any;

    let titleClass = '';
    if (usingDefault) {
      titleClass = classes.defaultDocument;
    }

    if (attachment) {
      const docusignInformation = attachment.docuSignEnvelopeInformation;

      var all = this.getFileInfo(attachment.contentType, classes);
      iconClass = all.iconClass;
      newWindow = all.newWindow;

      if (attachment.storageKey) {
        fileName = attachment.fileName;

        clickFn = this.onClick(
          attachment.fileName,
          attachment.storageKey,
          newWindow
        );
      } else if (attachment.documentPath) {
        var pathParts = attachment.documentPath.split('/');
        fileName = pathParts[pathParts.length - 1];

        clickFn = this.onClickDocumentPath(attachment.documentPath, newWindow);
      }
      if (
        defaultDocumentURL &&
        !attachment.storageKey &&
        !attachment.documentPath
      ) {
        var pathParts = defaultDocumentURL.split('/');
        fileName = pathParts[pathParts.length - 1];
        var all = this.getFileInfo('unknown', classes);
        iconClass = all.iconClass;
        newWindow = all.newWindow;

        clickFn = this.onClickDocumentPath(defaultDocumentURL, newWindow);
      }
    }

    if (clickFn) {
      documentView = (
        <div className={classes.document}>
          <Button
            size="large"
            className={classes.documentFileName + ' ' + titleClass}
            onClick={clickFn}>
            <i
              className={'far ' + iconClass + ' ' + classes.documentIcon}
              onClick={clickFn}
            />
            {fileName}
          </Button>
          {!preventDelete && !usingDefault && !readOnly && (
            <IconButton
              size="large"
              className={classes.deleteButton}
              aria-label="delete"
              onClick={this.onDelete(0, newWindow)}>
              <Icon>delete</Icon>
            </IconButton>
          )}
        </div>
      );
    }

    var docusignView: any = null;

    if (docusignInformation) {
      var docusignStatus: string = "Sent"; 
      if (docusignInformation.envelopeStatus && docusignInformation.envelopeStatus.status) {
        docusignStatus = docusignInformation.envelopeStatus.status
      }
      var iconClass = this.docusignStatusIconClass(docusignStatus);

      var recipientStatuses: Array<any>;

      if (
        docusignInformation.envelopeStatus &&
        docusignInformation.envelopeStatus.recipientStatuses &&
        docusignInformation.envelopeStatus.recipientStatuses.Statuses
      ) {
        recipientStatuses =
          docusignInformation.envelopeStatus.recipientStatuses.Statuses;
      }

      docusignView = (
        <div>
          <Tooltip key="docusign" title="Show E-sign Information">
            <IconButton onClick={this.handleShowHistory} size="large">
              <Icon className={iconClass + ' docusign-history'}>
                border_color
              </Icon>
            </IconButton>
          </Tooltip>
          <Menu
            id="history-menu"
            anchorEl={historyAnchorEl}
            open={Boolean(historyAnchorEl)}
            onClose={this.handleHistoryClose}>
            <ListSubheader color="primary" className={iconClass}>
              {docusignStatus}
            </ListSubheader>
            {recipientStatuses && recipientStatuses
              .reduce((acc: Array<any>, pv: any, idx: number) => {
                var v: any = pv;
                if (!v) {
                  return acc;
                }
                if (Object.keys(v).length == 0) {
                  return acc;
                }

                var actionDt: string = 'mm/dd/yyyy';
                var primary: any = null;
                var secondary: any = null;
                var status = (v.status || '').toLowerCase();

                switch (status) {
                  case 'completed':
                    secondary =
                      'Completed at ' +
                      moment(v.signed).format('MM/DD/YYYY hh:mm:ss a') +
                      ' by ' +
                      v.userName;
                    break;
                  case 'created':
                    secondary = 'Pending delivery to ' + v.userName;
                    break;
                  case 'sent':
                    secondary =
                      'Sent at ' +
                      moment(v.sent).format('MM/DD/YYYY hh:mm:ss a') +
                      ' by ' +
                      v.userName;
                    break;
                  case 'delivered':
                    secondary =
                      'Delivered at ' +
                      moment(v.delivered).format('MM/DD/YYYY hh:mm:ss a') +
                      ' by ' +
                      v.userName;
                    break;
                  case 'signed':
                    secondary =
                      'Signed at ' +
                      moment(v.signed).format('MM/DD/YYYY hh:mm:ss a') +
                      ' by ' +
                      v.userName;
                    break;
                  case 'declined':
                    secondary =
                      'Declined at ' +
                      moment(v.declined).format('MM/DD/YYYY hh:mm:ss a') +
                      ' by ' +
                      v.userName;
                    break;
                  default:
                    secondary =
                      'Unknown status (' +
                      v.status +
                      ') for recipient' +
                      v.userName;
                }

                var iconClass = this.docusignStatusIconClass(v.status);

                acc.push(
                  <MenuItem
                    key={idx}
                    onClick={this.onClick(v.fileName, v.storageKey, newWindow)}>
                    <ListItemIcon className={classes.icon}>
                      <Icon className={iconClass + ' docusign-recipient-icon'}>
                        border_color
                      </Icon>
                    </ListItemIcon>
                    <ListItemText
                      className={classes.text + ' docusign-recipient'}
                      inset
                      primary={v.email}
                      secondary={secondary}
                    />
                  </MenuItem>
                );

                return acc;
              }, [])
              .reverse()}
          </Menu>
        </div>
      );
    }

    var priorVersionsView: any = null;
    if (!suppressVersions) {
      priorVersionsView = (
        <div>
          <Tooltip key="history" title="Show prior versions">
            <IconButton onClick={this.handleShowHistory} size="large">
              <Icon>history</Icon>
            </IconButton>
          </Tooltip>
          <Menu
            id="history-menu"
            anchorEl={historyAnchorEl}
            open={Boolean(historyAnchorEl)}
            onClose={this.handleHistoryClose}>
            <ListSubheader color="primary" className={classes.subheader}>
              Prior Document Versions
            </ListSubheader>
            {priorVersions
              .reduce((acc: Array<any>, pv: any, idx: number) => {
                var v: any = pv;
                if (!v) {
                  return acc;
                }
                if (Object.keys(v).length == 0) {
                  return acc;
                }
                var {iconClass, newWindow} = this.getFileInfo(
                  v.contentType,
                  classes
                );
                var uploadedAt = moment(v.uploadedOn).format(
                  'MM/DD/YYYY hh:mm:ss a'
                );
                var secondary: any = null;
                if (v.uploadedBy && v.uploadedBy.name) {
                  secondary =
                    'Uploaded ' + uploadedAt + ' by ' + v.uploadedBy.name;
                }
                acc.push(
                  <MenuItem
                    key={idx}
                    onClick={this.onClick(v.fileName, v.storageKey, newWindow)}>
                    <ListItemIcon className={classes.icon}>
                      <i
                        className={
                          'far ' + iconClass + ' ' + classes.documentIcon
                        }
                      />
                    </ListItemIcon>
                    <ListItemText
                      className={classes.text}
                      inset
                      primary={v.fileName}
                      secondary={secondary}
                    />
                  </MenuItem>
                );

                return acc;
              }, [])
              .reverse()}
          </Menu>
        </div>
      );
    }
    let dropZone: any = null;
    if (status != 'uploading') {
      let prompt = this.state.prompt
      if (minimal) {
        dropZone = (
          <Dropzone
            style={{border: "black"}}
            multiple={false}
            minSize={minSize}
            maxSize={maxSize || MAX_FILE_SIZE}
            accept={this.state.accept}
            className={classes.dropzoneMin}
            activeClassName={classes.dropzoneActive}
            rejectClassName={classes.dropzoneReject}
            disabled={disabled || readOnly}
            disabledClassName={classes.dropzoneDisabled}
            onDrop={this.onDrop}>
            <Tooltip key="Upload" title="Upload New Version">
              <div  style={{width: 300, textAlign: "center", border: "#ddd dotted"}}>
                <IconButton name="uploadNewDocument" size="large">
                  <Icon>backup</Icon>
                </IconButton>
                Drop file to upload new document
              </div>
            </Tooltip>
          </Dropzone>
        );
      } else {
        dropZone = (
          <Dropzone
            multiple={false}
            minSize={minSize}
            maxSize={maxSize || MAX_FILE_SIZE}
            accept={this.state.accept}
            className={classes.dropzone}
            activeClassName={classes.dropzoneActive}
            rejectClassName={classes.dropzoneReject}
            disabledClassName={classes.dropzoneDisabled}
            disabled={disabled || readOnly}
            onDrop={this.onDrop}>
              <div>
                    <Tooltip key="Upload" title="Upload New Document">
                        <IconButton  name="uploadNewDocument" size="large">
                            <Icon>backup</Icon>
                        </IconButton>
                        <span>
                    </span>
                    </Tooltip>
                    <span>
                        {prompt}
                    </span>
              </div>
          </Dropzone>
        );
      }
    } else {
      // If we are uploading, then we just render the loading spinner
      dropZone = (
        <div className={classes.loading}>
          <CircularProgress color={'inherit'} size={20} thickness={3} />
        </div>
      );
    }

    if (minimal) {
      return (
        <div className={classes.container}>
          
          <FormControl
            disabled={disabled || readOnly}
            required={required}
            error={localError}>
            <FormLabel className={classes.compactLabel}>{label}</FormLabel>
            <FormGroup>
              <div className={classes.listArea}>
                {!readOnly && dropZone}
                {!suppressVersions &&
                  priorVersions.length > 0 &&
                  priorVersionsView}
                {docusignView}
                {documentView}
              </div>
            </FormGroup>
            {localHelperText && (
              <FormHelperText>{localHelperText}</FormHelperText>
            )}
          </FormControl>
        </div>
      );
    } else {
      return (
        <div className={classes.container}>
          <FormControl disabled={disabled || readOnly}>
            <FormLabel>{label}</FormLabel>
            <FormGroup>
              <div className={classes.listArea}>
                {!suppressVersions &&
                  PortalUserContext.isUserOfType(UserType.PortalAdmin) &&
                  priorVersions.length > 0 &&
                  priorVersionsView}
                {docusignView}
                {documentView}
                {!readOnly && dropZone}
              </div>
            </FormGroup>
            {localHelperText && (
              <FormHelperText>{localHelperText}</FormHelperText>
            )}
          </FormControl>
        </div>
      );
    }
  }
}

export default withStyles(styles)(VersionedDocumentField);
